import React, { cloneElement, FC } from 'react';
import { TranslationKey, useTranslations } from '@lang';
import { StyledLabel } from '../StyledLabel';
import Error from '../Error';
import { RadioField } from './RadioField';
import AssistiveText from '../FormElements/styled/AssistiveText';
import { RadioWrapper } from './RadioField/RadioField.style';
import { RadioGroupFieldWrapper } from './RadioGroupField.styles';

type RadioGroupFieldProps = {
  name: string;
  isDisabled?: boolean;
  input: {
    value: string;
    onChange: React.Dispatch<React.SetStateAction<string>>;
  };
  meta: {
    error: string;
    touched: boolean;
  };
  error: boolean;
  children?: any;
  label?: string;
  options?: { label: string; value: string; id: TranslationKey }[];
  key?: number;
  isRequired?: boolean;
};

export const RadioGroupField: FC<RadioGroupFieldProps> = ({
  name = '',
  input: { onChange, value },
  isDisabled = false,
  meta,
  error = meta.touched && meta.error,
  label,
  options,
  isRequired = false,
}) => {
  const { t } = useTranslations();

  return (
    <>
      <StyledLabel error={error} isRequired={isRequired}>
        {label}
      </StyledLabel>
      <RadioGroupFieldWrapper>
        {options &&
          options.map((option) => (
            <RadioWrapper key={option.value}>
              {cloneElement(
                <RadioField key={option.value} value={option.value}>
                  <>{t(option.id)}</>
                </RadioField>,
                {
                  isChecked: value === option.value,
                  onChange,
                  isDisabled,
                  error,
                  name,
                }
              )}
            </RadioWrapper>
          ))}
      </RadioGroupFieldWrapper>
      <AssistiveText>{error && <Error error={error} />}</AssistiveText>
    </>
  );
};
